<template>
  <div class="order-add-container">
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" :rules="rules" ref="form" label-width="140px">
        <el-row v-if="sourceType === '2'" class="parent-info">
          <el-col :span="12">
            <el-form-item label="订单类型">
              <span>{{ yxOrderTypeMap.get(parentData.orderType) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="待拆分规格">
              <span>{{ parentData.specName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="parentData.orderType === '1' ? '锁定单价' : '暂定单价'">
              <span>{{ parentData.lockedPrice }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="保证金类型">
              <span>{{ orderDepositTypeMap.get(parentData.orderDepositType) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="保证金比例">
              <span>{{ parentData.orderDeposit }}{{ parentData.orderDepositType && parentData.orderDepositType === '2' ? (parentData.specUnit ? '/' + parentData.specUnit : '') : '%' }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合同编号">
              <span>{{ parentData.contractNo || "" }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="锁定数量">
              <span>{{ parentData.orderQuantity }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="可用数量">
              <span>{{ availableQuantity }}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <template v-if="sourceType === '2'">
              <el-form-item label="采购方" prop="userId">
                <el-select v-model="formData.userId" disabled filterable placeholder="请选择采购方" @change="onConfrimUser">
                  <el-option v-for="(item, index) of userList1" :value="item.userId" :label="item.userName"
                             :key="index"></el-option>
                </el-select>
              </el-form-item>
            </template>
            <template v-else>
              <el-form-item label="采购方" prop="userId">
                <el-select v-model="formData.userId" :disabled="!!formData.demandId" filterable placeholder="请选择采购方" @change="onConfrimUser">
                  <el-option v-for="(item, index) of userList1" :value="item.userId" :label="item.userName"
                             :key="index"></el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属供应商" prop="supplierId" v-if="sourceType === '3'">
              <el-select v-model="formData.supplierId" :disabled="!!formData.demandId" filterable placeholder="请选择供应商">
                <el-option v-for="(item, index) of userList" :value="item.userId" :label="item.userName"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <template v-if="sourceType === '3'">
            <el-col :span="12">
              <el-form-item label="点价类型" prop="orderType" :rules="[{ required: true, message: '请选择点价类型', trigger: 'change' }]">
                <el-select v-model="formData.orderType" :disabled="!!formData.demandId && sourceDemand.demandType !== '3'" placeholder="请选择点价类型">
                  <el-option label="一口价" value="1" /><el-option label="暂定价" value="2" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="关联采购询价">
                <el-select v-model="formData.demandId" clearable filterable :disabled="formData.orderItems.length > 1" placeholder="可选，不关联可留空"
                           @change="onDemandChange">
                  <el-option v-for="item in demandList" :key="item.demandId"
                             :label="item.demandNumber + ' ' + item.demandTitle" :value="item.demandId" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="关联采购报价">
                <el-select v-model="formData.quoteId" clearable filterable :disabled="!formData.demandId"
                           placeholder="请选择采购报价" @change="onQuoteChange">
                  <el-option v-for="item in quoteList" :key="item.quoteId"
                             :label="item.supplierName + ' / ' + item.quotePrice + '元 / ' + item.quoteQuantity"
                             :value="item.quoteId" />
                </el-select>
              </el-form-item>
            </el-col>
          </template>

          <el-col v-if="sourceType !== '3'" :span="12">
            <el-form-item label="品种规格" prop="specId">
              <!-- <el-select v-model="formData.specId" filterable
                :disabled="(sourceType === '1' || (formData.orderType === '2' && formData.parentOrderId))"
                placeholder="请选择品种规格" @change="onConfirmSpec">
                <el-option v-for="(item, index) of goodsList" :value="item.specId" :label="item.specName"
                  :key="index"></el-option>
              </el-select> -->
              <el-input :disabled="(!!formData.demandId || sourceType === '1' || (formData.orderType === '2' && !!formData.parentOrderId))" clearable v-model="specName"
                @focus="dialogVisible = true" placeholder="品种规格" />

            </el-form-item>
          </el-col>

          <el-col v-if="sourceType !== '3'" :span="12">
            <el-form-item :label="(formData.orderType === '2' && formData.parentOrderId) ? '拆分数量' : '采购数量'"
              prop="orderQuantity">
              <el-input-number v-model="formData.orderQuantity" :disabled="!!formData.demandId" :min="0.001" :step="0.001" :precision="3"
                placeholder="请输入数量"></el-input-number>
            </el-form-item>
          </el-col>

          <el-col v-if="sourceType !== '3'" :span="12">
            <el-form-item :label="formData.orderType === '1' ? '采购单价' : (formData.parentOrderId ? '确认单价' : '暂定单价')"
              prop="lockedPrice">
              <!-- <el-input v-if="formData.parentOrderId && formData.orderType === '2'" v-model="formData.lockedPrice"
                type="number" placeholder="请输入单价"></el-input>
              <span v-else>{{ formData.lockedPrice }}</span> -->
              <el-input v-model="formData.lockedPrice" v-if="sourceType === '2'"  placeholder="请输入单价" @change="lockedPriceChange"></el-input>
              <el-input v-model="formData.lockedPrice" v-else :disabled="!!formData.demandId" placeholder="请输入单价"></el-input>
            </el-form-item>
          </el-col>
          <template v-if="formData.parentOrderId">
            <el-col :span="12">
              <el-form-item label="价格差">
                <span>{{ formData.priceDiff }}</span>
              </el-form-item>
            </el-col>
          </template>
          <template v-else>
            <el-col :span="12">
              <el-form-item label="保证金类型" prop="orderDepositType">
                <el-radio-group v-model="formData.orderDepositType" @change="formData.orderDeposit = ''">
                  <el-radio v-for="(item, index) of orderDepositTypeList" :value="item.value"
                            :label="item.value"
                            :key="index">{{ item.label }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <template v-if="formData.orderDepositType === '2'">
                <el-form-item label="保证金比例" prop="orderDeposit">
                  <el-input-number v-model="formData.orderDeposit" :step="1" step-strictly :min="0"></el-input-number>
                </el-form-item>
              </template>
              <template v-else>
                <el-form-item label="保证金比例" prop="orderDeposit">
                  <el-input-number v-model="formData.orderDeposit" :step="1" step-strictly :min="0"
                                   :max="100"></el-input-number>
                </el-form-item>
              </template>
            </el-col>

<!--            <el-col :span="12">-->
<!--              <el-form-item label="保证金">-->
<!--                <span>{{ formatBond }}</span>-->
<!--                <span class="ml10"-->
<!--                      :class="{ 'text-red': Number(formatBond) > formatBalance && !formData.parentOrderId }">可用余额：{{-->
<!--                    formatBalance || '' }}</span>-->
<!--              </el-form-item>-->
<!--            </el-col>-->

            <el-col :span="12">
              <el-form-item label="合同编号" prop="contractNo">
                <el-input v-model="formData.contractNo" placeholder="请输入合同编号"></el-input>
              </el-form-item>
            </el-col>
            <!-- 点价约定仅适用于暂定价订单，一口价新增和编辑均不展示。 -->
            <el-col v-if="formData.orderType === '2'" :span="12">
              <el-form-item label="最晚点价日期" prop="latestPriceDate">
                <el-date-picker v-model="formData.latestPriceDate" value-format="yyyy-MM-dd" placeholder="请选择最晚点价日期"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col v-if="formData.orderType === '2'" :span="12">
              <el-form-item label="期货合约" prop="futuresContract">
                <el-input v-model="formData.futuresContract" placeholder="请输入期货合约"></el-input>
              </el-form-item>
            </el-col>
            <el-col v-if="formData.orderType === '2'" :span="12">
              <el-form-item label="基差" prop="basisPrice">
                <el-input-number v-model="formData.basisPrice" :precision="2" :step="1"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="损耗承担方" prop="lossBearer">
                <el-radio-group v-model="formData.lossBearer">
                  <el-radio label="1">采购方</el-radio>
                  <el-radio label="2">供应商</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </template>

          <template v-if="formData.orderType === '2' && sourceType === '2'">
            <!-- 暂定价子订单可在新增时录入自身的外部点价编号。 -->
            <el-col :span="12">
              <el-form-item label="外部点价编号" prop="priceOrderNo">
                <el-input v-model="formData.priceOrderNo" maxlength="100" clearable placeholder="请输入外部点价编号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否关联提货单" :rules="{ required: true, message: '请选择是否关联提货单' }">
                <el-radio-group v-model="isHasLink" @change="isHasLinkChange">
                  <el-radio label="1">是</el-radio>
                  <el-radio label="2">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </template>
        </el-row>
        <div v-if="sourceType === '3'" class="order-items">
          <div class="order-items-toolbar">
            <span>订单明细（{{ formData.orderItems.length }} 行）</span>
            <el-button type="primary" size="small" :disabled="!!formData.demandId" @click="addOrderItem">添加</el-button>
          </div>
          <p class="order-items-tip">每行生成一个订单，共用上方信息及附件，订单编号按行顺序递增。{{ formData.demandId ? '关联询价时，明细以询价及报价为准。' : '' }}</p>
          <el-table :data="formData.orderItems" row-key="rowKey" border>
            <el-table-column type="index" label="序号" width="65" />
            <el-table-column label="品种规格" min-width="260">
              <template v-slot="{ row, $index }">
                <el-form-item :prop="`orderItems.${$index}.specId`" :rules="rules.specId" label-width="0">
                  <el-input :value="row.specName" readonly :disabled="!!formData.demandId"
                            placeholder="请选择品种规格" @focus="chooseOrderItemSpec(row)" />
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="数量" min-width="200">
              <template v-slot="{ row, $index }">
                <el-form-item :prop="`orderItems.${$index}.orderQuantity`" :rules="rules.orderQuantity" label-width="0">
                  <el-input-number v-model="row.orderQuantity" :disabled="!!formData.demandId"
                                   :min="0.001" :step="0.001" :precision="3" placeholder="请输入数量" />
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column :label="formData.orderType === '2' ? '暂定单价' : '单价'" min-width="180">
              <template v-slot="{ row, $index }">
                <el-form-item :prop="`orderItems.${$index}.lockedPrice`" :rules="rules.lockedPrice" label-width="0">
                  <el-input v-model="row.lockedPrice" :disabled="!!formData.demandId" placeholder="请输入单价" />
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="85">
              <template v-slot="{ $index }">
                <el-button type="text" :disabled="!!formData.demandId || formData.orderItems.length === 1"
                           @click="removeOrderItem($index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
          <template v-if="isHasLink === '1'">
            <el-row>
              <el-form-item prop="lockedList" label="关联提货单">
                <el-row>
                  <el-button class="mb15" type="primary" @click="addLockedOrder">新增关联提货单</el-button>
                  <span style="margin-left: 20px;">关联总量：<b>{{ totalPickupQty }}</b></span>
                </el-row>
                <el-table :data="formData.lockedList">
                  <el-table-column min-width="150" prop="pickupNumber" label="提货编号"></el-table-column>
                  <el-table-column min-width="150" prop="realPickupQuantity" label="实提数量"></el-table-column>
                  <el-table-column label="车牌号" prop="vehicleKey"></el-table-column>
                  <!-- 展示关联提货单的司机姓名，便于核对车辆信息。 -->
                  <el-table-column label="司机姓名" prop="driverName"></el-table-column>
                  <el-table-column min-width="150" prop="pickupQuantity" label="关联数量">
                    <template v-slot="{ row, $index }">
                      <el-form-item :prop="`lockedList.${$index}.pickupQuantity`">
                        <el-input v-model="row.pickupQuantity" placeholder="请输入关联数量" />
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column fixed="right" label="操作">
                    <template v-slot="{ $index }">
                      <el-button type="text" @click="deleteLockedOrder($index)" class="del-btn">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
            </el-row>
          </template>
          <el-row>
          <el-col :span="24">
            <el-form-item label="附件">
              <file-upload v-model="formData.fileList"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-button type="primary" :loading="submitting" @click="submit">提交</el-button>
          <el-button @click="$router.back()">取消</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <SpecChoose :visible.sync="dialogVisible" @select="onSpecSelect"></SpecChoose>
    <LinkOrderChoose :visible="showLinkOrderDialog" @close="showLinkOrderDialog = false" :orderId="this.formData.parentOrderId" :selectIds="selectIds" @confirm="addLockedList"></LinkOrderChoose>
  </div>
</template>

<script>
import { validInteger, validNumber3 } from '@/utils/validator'
import { yxOrderType, orderDepositType } from '@/utils/dict'
import BigNumber from 'bignumber.js'
import SpecChoose from '@/components/SpecChoose.vue'
import LinkOrderChoose from './LinkOrderChoose.vue'
import { mapToObjectArray } from '@/utils/utils'

let orderItemKey = 0
const createOrderItem = () => ({
  rowKey: ++orderItemKey,
  specId: '',
  specName: '',
  isBulkOil: '',
  orderQuantity: undefined,
  lockedPrice: ''
})

export default {
  components: {
    SpecChoose,
    LinkOrderChoose
  },
  data() {
    return {
      dialogVisible: false,
      activeOrderItem: null,
      submitting: false,
      yxOrderTypeMap: yxOrderType,
      orderDepositTypeMap: orderDepositType,
      orderDepositTypeList: mapToObjectArray(orderDepositType),
      salesmanRole: '1',
      showPicker: false,
      showCustomer: false,
      showOrderDeposit: false,
      specName: '',
      userName: '',
      goodsList: [],
      userList: [],
      userList1: [],
      orderDepositName: '',
      orderDepositList: [
        { name: '10%', value: '10' },
        { name: '20%', value: '20' },
        { name: '30%', value: '30' },
        { name: '40%', value: '40' },
        { name: '50%', value: '50' },
        { name: '60%', value: '60' },
        { name: '70%', value: '70' },
        { name: '80%', value: '80' },
        { name: '90%', value: '90' },
        { name: '100%', value: '100' }
      ],
      isHasLink: '',
      showLinkOrderDialog: false,
      selectIds: [],
      formData: {
        orderType: '',
        supplierId: '',
        userId: '',
        specId: '',
        isBulkOil: '',
        lockedPrice: '',
        orderQuantity: '',
        orderItems: [createOrderItem()],
        usedQuantity: '',
        lockedDeposit: '',
        parentOrderId: '',
        priceDiff: '0',
        orderDepositType: '1',
        orderDeposit: '',
        contractNo: '',
        priceOrderNo: '', // 暂定价子订单的外部点价编号，可选填写
        latestPriceDate: '', // 合同约定的最晚点价日期
        futuresContract: '', // 点价对应的期货合约
        basisPrice: undefined, // 人工录入基差，保留两位小数
        lossBearer: '1', // 损耗承担方默认采购方，保持历史结算口径
        demandId: '', // 可选关联的采购询价ID
        quoteId: '', // 可选关联的采购报价ID
        lockedList: [],
        fileList: []
      },
      rules: {
        userId: [{ required: true, message: '请选择客户', trigger: 'change' }],
        specId: [{ required: true, message: '请选择品种规格', trigger: 'change' }],
        supplierId: [{ required: true, message: '请选择供应商', trigger: 'change' }],
        lockedPrice: [
          { required: true, message: '请输入单价', trigger: 'change' },
          { pattern: validNumber3, message: '请输入正确的单价', trigger: 'change' }
        ],
        orderQuantity: [{ required: true, message: '请输入数量', trigger: 'blur' }],
        orderDeposit: [{ required: true, message: '请选择保证金比例', trigger: 'change' }],
        contractNo: [{ required: true, message: '请输入合同编号', trigger: 'change' }],
        lockedList: [{ required: true, message: '请添加关联提货单', trigger: 'change' }]
      },
      parentData: {
        orderType: '',
        userId: '',
        specId: '',
        lockedPrice: '',
        orderQuantity: '',
        parentOrderId: '',
        priceDiff: '0',
        orderDeposit: '',
        fileList: []
      },
      specData: {
        specId: '',
        typeId: '',
        specName: '',
        priceDiff: '',
        createUserId: '',
        isBulkOil: '',
        unit: '',
        specImage: ''
      },
      bondData: {
        depositAfterChange: '',
        depositChange: '',
        depositAllChange: ''
      },
      priceList: [],
      demandList: [],
      // 保存已加载的询价快照，用于类型控制及异步回填状态校验。
      sourceDemand: {},
      sourceLoading: false,
      quoteList: []
    }
  },
  watch: {
    // 'formData.specId'(val) {
    //   this.loadPriceData(val).then(() => {
    //     this.computedPriceByNumUp(this.priceList, this.formData.orderQuantity)
    //   })
    //   // this.loadSetting(this.formData.isBulkOil)
    // },
    // 'formData.orderQuantity'(val) {
    //   this.computedPriceByNumUp(this.priceList, val)
    // },
    formatBond(val) {
      this.formData.lockedDeposit = val
    }
  },
  computed: {
    orderType() {
      return this.$route.query.orderType || ''
    },
    orderId() {
      return this.$route.query.orderId || ''
    },
    sourceType() {
      return this.$route.query.sourceType || '3'
    },
    userId() {
      return this.$route.query.userId || ''
    },
    sourceDemandId() {
      return this.$route.query.demandId || ''
    },
    userInfo() {
      return this.$store.state.user
    },
    showBond() {
      return this.formData.orderDeposit && this.formData.lockedPrice && this.formData.orderQuantity && !this.formData.parentOrderId
    },
    formatBalance() {
      return parseFloat(this.bondData.depositAfterChange)
    },
    // 实时计算拆分后的可用数量，超量时显示负数，固定保留三位小数。
    availableQuantity() {
      return new BigNumber(this.parentData.orderQuantity || 0)
        .minus(this.parentData.usedQuantity || 0)
        .minus(this.parentData.usedAddQuantity || 0)
        .minus(this.formData.orderQuantity || 0)
        // 暂定价关联提货转入子单后，应恢复父单原来被该部分提货占用的数量。
        .plus(this.isHasLink === '1' ? this.totalPickupQty : 0)
        .toFixed(3)
    },
    formatBond() {
      if (this.showBond) {
        const lockedPrice = new BigNumber(this.formData.lockedPrice || 0)
        const orderQuantity = new BigNumber(this.formData.orderQuantity || 0)
        const num = new BigNumber(parseInt(this.formData.orderDeposit) / 100)
        const res = lockedPrice.times(orderQuantity).times(num)
        return res.toFixed(2)
      } else {
        return '0'
      }
    },
    // 计算实提数量总和
    totalPickupQty() {
      const total = this.formData.lockedList.reduce((sum, item) => {
        return sum + Number(item.pickupQuantity || 0)
      }, 0)
      return Number(total.toFixed(3))
    }
  },
  created() {
    this.loadUserList()
    this.loadUserList1()
    this.formData.orderType = this.orderType || ''
    if (this.sourceType === '2') {
      this.formData.parentOrderId = this.orderId
      this.loadParentData().then(() => {
        this.loadGoodsList().then(() => {
          if (this.formData.orderType === '2') {
            const specData = this.goodsList.find(item => item.specId === this.parentData.specId)
            this.onConfirm(specData)
          }
        })
        this.loadSpecData()
      })
    }
    if (this.sourceType === '3') {
      this.loadGoodsList()
      // 新建主采购单时加载可选询价；从询价列表跳转时自动回填关联关系。
      this.loadDemandList().then(() => {
        if (this.sourceDemandId) {
          this.formData.demandId = this.sourceDemandId
          this.onDemandChange(this.sourceDemandId)
        }
      })
    }
    this.loadDict()
  },
  methods: {
    addOrderItem() {
      if (!this.formData.demandId) this.formData.orderItems.push(createOrderItem())
    },
    removeOrderItem(index) {
      if (this.formData.demandId || this.formData.orderItems.length === 1) return
      this.formData.orderItems.splice(index, 1)
      this.$nextTick(() => this.$refs.form.clearValidate())
    },
    chooseOrderItemSpec(row) {
      this.activeOrderItem = row
      this.dialogVisible = true
    },
    loadDemandList() {
      return this.$axios.get(this.$apis.yxcPurchaseDemand.selectYxcPurchaseDemandByPage, {
        page: 1,
        size: 9999,
        demandStatus: '1'
      }).then(res => {
        this.demandList = res.list || []
      })
    },
    onDemandChange(demandId) {
      // 切换来源先清空受控值，避免旧报价、供应商或价格残留到新询价。
      this.sourceDemand = {}
      this.formData.orderItems = [createOrderItem()]
      this.activeOrderItem = null
      this.formData.quoteId = ''
      this.quoteList = []
      this.formData.userId = ''
      this.formData.specId = ''
      this.specName = ''
      this.formData.orderQuantity = undefined
      this.formData.supplierId = ''
      this.formData.lockedPrice = ''
      this.formData.orderType = demandId ? '' : this.orderType
      this.sourceLoading = !!demandId
      if (!demandId) return Promise.resolve()
      return this.$axios.get(this.$apis.yxcPurchaseDemand.selectYxcPurchaseDemandById, {
        demandId
      }).then(res => {
        // 用户快速切换时忽略旧响应，保证页面字段始终属于当前选中的询价。
        if (this.formData.demandId !== demandId) return
        if (!res || res.demandStatus !== '1') throw new Error('询价不可用')
        this.sourceDemand = { ...res, demandType: res.demandType || '3' }
        this.formData.orderType = ['1', '2'].includes(res.demandType) ? res.demandType : ''
        this.formData.userId = res.userId
        this.formData.specId = res.specId
        this.specName = res.specName
        this.formData.orderQuantity = Number(res.demandQuantity)
        Object.assign(this.formData.orderItems[0], {
          specId: res.specId,
          specName: res.specName,
          isBulkOil: res.isBulkOil || '',
          orderQuantity: Number(res.demandQuantity)
        })
        this.quoteList = res.quoteList || []
        this.sourceLoading = false
        if (this.quoteList.length === 1) {
          this.formData.quoteId = this.quoteList[0].quoteId
          this.onQuoteChange(this.formData.quoteId)
        }
      }).catch(() => {
        if (this.formData.demandId === demandId) this.$message.error('询价加载失败，请重新选择')
      })
    },
    onQuoteChange(quoteId) {
      // 供应商与价格必须来自同一份报价，清空报价时一并清空。
      const quote = this.quoteList.find(item => item.quoteId === quoteId)
      this.formData.supplierId = quote ? quote.supplierId : ''
      this.formData.lockedPrice = quote ? quote.quotePrice : ''
      this.formData.orderItems[0].lockedPrice = this.formData.lockedPrice
    },
    isHasLinkChange(val) {
      console.log('isHasLinkChange', val)
    },
    onSpecSelect(data) {
      if (this.sourceType === '3') {
        const row = this.activeOrderItem
        if (row && this.formData.orderItems.includes(row)) {
          row.specId = data.specId
          row.specName = data.specName
          row.isBulkOil = data.isBulkOil || ''
          const index = this.formData.orderItems.indexOf(row)
          this.$nextTick(() => this.$refs.form.validateField(`orderItems.${index}.specId`))
        }
        this.dialogVisible = false
        return
      }
      console.log('data', data)
      this.formData.specId = data.specId
      this.specName = data.specName
      this.dialogVisible = false
    },
    loadSetting(isBulkOil) {
      this.$axios.get(this.$apis.yxcOrderManage.selectYxcPriceNumByNumId, {
        numId: isBulkOil
      }).then(res => {
        if (res.orderMinNum === res.orderMaxNum && res.orderMinNum > 0) {
          this.formData.orderQuantity = res.orderMinNum
        }
      })
    },
    loadDict() {
      this.$axios.get(this.$apis.common.selectDicByList, { dicType: 'bzjbl' }).then(res => {
        this.orderDepositList = res.bzjbl.map(item => {
          return {
            name: item.dicValue,
            value: item.dicCode
          }
        })
      })
    },
    onConfrimOrderDeposit(data) {
      this.formData.orderDeposit = data.value
      this.orderDepositName = data.name
      this.showOrderDeposit = false
    },
    // formatBond() {
    //   const lockedPrice = new BigNumber(this.formData.lockedPrice || 0)
    //   const orderQuantity = new BigNumber(this.formData.orderQuantity || 0)
    //   const num = new BigNumber(parseInt(this.formData.orderDeposit) / 100)
    //   const res = lockedPrice.times(orderQuantity).times(num)
    //   return res.toFixed(2)
    // },
    loadUserList() {
      this.$axios.get(this.$apis.patrolProblemReport.selectIparkUserByRole, {
        userType: '4'
      }).then(res => {
        this.userList = res || []
      })
    },
    loadUserList1() {
      this.$axios.get(this.$apis.system.selectSysUserByList, {
        userType: '2,3',
        yxcQx: '1'
      }).then(res => {
        this.userList1 = res || []
      })
    },
    loadBond() {
      this.$axios.get(this.$apis.yxcUserBond.selectYxcUserDepositByDepositId, {
        userId: this.formData.userId
      }).then(res => {
        const bondData = Array.isArray(res.list) ? (res.list[0] || {}) : res
        this.bondData.depositAfterChange = bondData.depositAfterChange || '0'
        this.bondData.depositChange = bondData.depositChange || '0'
        this.bondData.depositAllChange = bondData.depositAllChange || '0'
      })
    },
    loadParentData() {
      return this.$axios.get(this.$apis.yxcOrderManage.selectYxcPriceOrderByOrderId, {
        orderId: this.formData.parentOrderId
      }).then((res) => {
        this.specName = res.specName || ''
        this.formData.specId = res.specId || ''
        this.parentData = res
        this.formData.orderDeposit = res.orderDeposit
        this.formData.userId = res.userId || ''
      })
    },
    loadSpecData() {
      this.$axios.get(this.$apis.priceControl.selectYxSpecPriceById, {
        specId: this.parentData.specId
      }).then((res) => {
        this.specData = res
      })
    },
    computedPriceByNumUp(data, target) {
      if (this.formData.parentOrderId) {
        return
      }
      if (this.formData.specId && this.priceList.length) {
        if (this.priceList.length === 1) {
          this.formData.lockedPrice = this.priceList[0].specPrice
        } else {
          if (validInteger.test(target)) {
            const filtered = data.filter(item => item.numUp <= target)
            if (filtered.length === 0) {
              this.$message.error('价格表错误')
              return null
            }
            const maxItem = filtered.reduce((prev, curr) => curr.numUp > prev.numUp ? curr : prev)
            this.formData.lockedPrice = maxItem.specPrice
          }
        }
      }
    },
    loadPriceData(specId) {
      return this.$axios.get(this.$apis.priceControl.selectYxSpecPriceById, {
        specId
      }).then(res => {
        this.priceList = res.priceList || []
      })
    },
    onConfirmSpec() {
      const item = this.goodsList.find(g => g.specId === this.formData.specId)
      if (item) {
        this.onConfirm(item)
      }
    },
    onConfirm(item) {
      if (!item) return
      // this.formData.specId = item.specId
      this.formData.isBulkOil = item.isBulkOil
      // this.formData.priceDiff = item.priceDiff - this.specData.priceDiff
      if (this.formData.parentOrderId && this.formData.orderType === '1') {
        this.formData.lockedPrice = parseFloat(this.parentData.lockedPrice) + parseFloat(this.formData.priceDiff)
      }
      console.log('this.formData', this.formData)
      // this.specName = item.specName
    },
    onConfrimUser() {
      this.loadBond()
    },
    loadGoodsList() {
      return this.$axios.get(this.$apis.priceControl.selectYxSpecPriceByList, {
        page: 1,
        size: 9999
        // isDisplay: this.sourceType === '3' ? '1' : ''
        // typeId: this.parentData.typeId
      }).then((res) => {
        if (this.parentData.orderType === '2') {
          this.goodsList = res.list
        } else {
          this.goodsList = res.list.filter(item => item.specName !== this.parentData.specName)
        }
      })
    },
    lockedPriceChange(val) {
      this.formData.priceDiff = Number(((val * 1000 - this.parentData.lockedPrice * 1000) / 1000).toFixed(3))
    },
    addLockedOrder() {
      if (this.formData.lockedList && this.formData.lockedList.length) {
        this.selectIds = this.formData.lockedList.map(item => item.pickupId)
      } else {
        this.selectIds = []
      }
      this.showLinkOrderDialog = true
      console.log('addLockedOrder  selectIds', this.selectIds)
    },
    // 关联数量与实提数量统一使用损耗结算口径，重新选择时保留手工填写的关联数量。
    addLockedList(list) {
      console.log('addLockedList', list)
      const newData = list || []
      newData.forEach(newItem => {
        console.log('newData', newItem)
        newItem.realPickupQuantity = newItem.settlementQuantity ?? '0'
        const existItem = this.formData.lockedList.find(item => item.pickupId === newItem.pickupId)
        if (existItem && existItem.pickupQuantity) {
          newItem.pickupQuantity = existItem.pickupQuantity
        } else {
          newItem.pickupQuantity = newItem.realPickupQuantity
        }
      })
      this.formData.lockedList = newData
    },
    deleteLockedOrder(index) {
      this.formData.lockedList.splice(index, 1)
    },
    submit() {
      if (this.submitting) return
      if (this.sourceLoading || (this.formData.demandId && !this.formData.quoteId)) {
        this.$message.error('请等待询价加载完成并选择有效采购报价')
        return
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.sourceType === '3') {
            if (!this.formData.orderItems.length) {
              this.$message.error('请至少添加一行订单明细')
              return
            }
            for (const [index, item] of this.formData.orderItems.entries()) {
              if (!item.specId) {
                this.$message.error(`第${index + 1}行：请选择品种规格`)
                return
              }
              if (!validNumber3.test(item.orderQuantity) || Number(item.orderQuantity) <= 0) {
                this.$message.error(`第${index + 1}行：数量必须大于0，最多保留三位小数`)
                return
              }
            }
          }
          if (this.sourceType !== '3' && !this.formData.lockedPrice) {
            if (this.formData.orderType === '1') {
              this.$message.error('请输入锁定单价')
              return
            }
            if (this.formData.orderType === '2') {
              if (this.formData.parentOrderId) {
                this.$message.error('请输入确认单价')
                return
              } else {
                this.$message.error('请输入暂定单价')
                return
              }
            }
          }
          if (this.sourceType !== '3' && (!validNumber3.test(this.formData.orderQuantity) || Number(this.formData.orderQuantity) <= 0)) {
            this.$message.error('数量必须大于0，最多保留三位小数')
            return
          }
          // 锁价和拆分允许超过可用数量，由余量显示超出的负数。
          // if (!this.formData.parentOrderId && parseFloat(this.formatBond) > this.formatBalance) {
          //   this.$message.error('保证金不足，请充值')
          //   return
          // }
          if (this.formData.orderType === '2' && this.sourceType === '2' && this.isHasLink === '') {
            this.$message.error('请先选择是否关联提货单')
            return
          }
          if (this.isHasLink === '1') {
            if (this.formData.lockedList && this.formData.lockedList.length > 0) {
              for (const item of this.formData.lockedList) {
                if (!item.pickupQuantity) {
                  this.$message.error('请输入关联数量')
                  return
                }
                if (!validNumber3.test(item.pickupQuantity)) {
                  this.$message.error('关联数量大于0，可保留三位小数')
                  return
                }
                // 允许超量关联，后端按实际关联数量拆分并保留负数余量。
              }
            } else {
              this.$message.error('请添加关联提货单')
              return
            }
          }
          const data = JSON.parse(JSON.stringify(this.formData))
          if (this.sourceType === '3') {
            data.orderItems = data.orderItems.map(({ specId, isBulkOil, orderQuantity, lockedPrice }) => ({
              specId, isBulkOil, orderQuantity, lockedPrice
            }))
            delete data.specId
            delete data.isBulkOil
            delete data.orderQuantity
            delete data.lockedPrice
          } else {
            delete data.orderItems
          }
          if (this.isHasLink === '1') {
            data.lockedList = data.lockedList.map(item => {
              return {
                pickupId: item.pickupId,
                pickupQuantity: item.pickupQuantity
              }
            })
          }
          this.submitting = true
          this.$axios.post(this.$apis.yxcOrderManage.insertYxcPriceOrder, data).then(() => {
            this.$message.success(this.sourceType === '3' ? `成功生成${data.orderItems.length}个订单` : '提交成功')
            this.$router.back()
          }).finally(() => {
            this.submitting = false
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.order-add-container {
  //padding: 20px;

  ::v-deep {

    .el-select,
    .el-input-number {
      width: 100%;
    }
  }
}

.parent-info {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.order-items {
  margin: 8px 0 24px;

  ::v-deep .el-form-item {
    margin: 12px 0 20px;
  }
}

.order-items-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
}

.order-items-tip {
  color: #909399;
  font-size: 13px;
}

.price-items {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.price-item {
  display: flex;
  gap: 10px;
  padding: 8px 12px;
  background: #f8f9fa;
  border-radius: 4px;
}

.text-red {
  color: #f56c6c;
}

.ml10 {
  margin-left: 10px;
}
</style>
